import React, { Component } from 'react';
import { func, element, oneOfType, arrayOf } from 'prop-types';

class ErrorBoundary extends Component {
    static getDerivedStateFromError() {
        return { hasError: true };
    }

    constructor(props) {
        super(props);

        this.state = { hasError: false };
        this.onError = props.onError;
    }

    componentDidCatch(err) {
        this.onError(err);
    }

    render() {
        const { hasError } = this.state;

        if (hasError) {
            return null;
        }

        return this.props.children;
    }
}

ErrorBoundary.propTypes = {
    /**
     * callback to run when component caught an error
     */
    onError: func,

    /**
     * component(s) to render
     */
    children: oneOfType([element, arrayOf(element)])
};

export default ErrorBoundary;
